import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs } from '../Breadcrumbs';
export const GlobalHeader = ({}) => {
    return (_jsx("header", { className: 'global-header px-container-x py-3 gap-2 bg-sidebar border-b pb-0 w-full h-fit', children: _jsxs("div", { className: 'flex gap-2 mb-3', children: [_jsx(Breadcrumbs, {}), _jsx("div", { className: 'global-header--actions ml-auto flex items-start gap-2' })] }) }));
};
